(function() {
    'use strict';

    let faqResizeListenerAttached = false;

    function initFAQSection() {
        const faqSections = document.querySelectorAll('.faq-section');
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (faqSections.length === 0) {
            return;
        }

        faqSections.forEach(section => {
            const faqItems = section.querySelectorAll('.faq-item');
            
            faqItems.forEach(item => {
                const button = item.querySelector('.faq-question');
                const answer = item.querySelector('.faq-answer');

                // Click handler
                button.addEventListener('click', function(e) {
                    e.preventDefault();
                    const isActive = item.classList.contains('active');

                    // Close all other items in this section
                    faqItems.forEach(otherItem => {
                        if (otherItem !== item && otherItem.classList.contains('active')) {
                            closeItem(otherItem);
                        }
                    });

                    // Toggle current item
                    if (isActive) {
                        closeItem(item);
                    } else {
                        openItem(item);
                    }
                }, { passive: false });

                // Keyboard handler
                button.addEventListener('keydown', function(e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        button.click();
                    }
                });

                // Touch event handlers for mobile
                if ('ontouchstart' in window) {
                    button.addEventListener('touchstart', function(e) {
                        if (e.touches.length > 1) {
                            e.preventDefault();
                        }
                    }, { passive: false });
                    
                    button.addEventListener('touchend', function(e) {
                        e.preventDefault();
                        setTimeout(() => {
                            button.click();
                        }, 10);
                    }, { passive: false });
                }
            });

            // CTA link touch events
            const ctaLinks = section.querySelectorAll('.cta-link');
            if ('ontouchstart' in window) {
                ctaLinks.forEach(link => {
                    link.addEventListener('touchstart', function(e) {
                        if (e.touches.length > 1) {
                            e.preventDefault();
                        }
                    }, { passive: false });
                });
            }

            function openItem(item) {
                const button = item.querySelector('.faq-question');
                const answer = item.querySelector('.faq-answer');

                if (prefersReducedMotion) {
                    item.classList.add('active');
                    answer.style.height = 'auto';
                    button.setAttribute('aria-expanded', 'true');
                } else {
                    item.classList.add('active');
                    const targetHeight = answer.scrollHeight;
                    answer.style.height = targetHeight + 'px';
                    button.setAttribute('aria-expanded', 'true');

                    const transitionHandler = function() {
                        if (item.classList.contains('active')) {
                            answer.style.height = 'auto';
                        }
                        answer.removeEventListener('transitionend', transitionHandler);
                    };

                    answer.addEventListener('transitionend', transitionHandler);
                }

                // Scroll into view if needed
                if (!prefersReducedMotion) {
                    setTimeout(() => {
                        const rect = item.getBoundingClientRect();
                        const headerOffset = 140;
                        if (rect.top < headerOffset) {
                            window.scrollTo({
                                top: window.pageYOffset + rect.top - headerOffset,
                                behavior: 'smooth'
                            });
                        }
                    }, 100);
                }
            }

            function closeItem(item) {
                const button = item.querySelector('.faq-question');
                const answer = item.querySelector('.faq-answer');

                if (prefersReducedMotion) {
                    item.classList.remove('active');
                    answer.style.height = '0';
                    button.setAttribute('aria-expanded', 'false');
                } else {
                    item.classList.add('closing');
                    item.classList.remove('active');

                    const currentHeight = answer.scrollHeight;
                    answer.style.height = currentHeight + 'px';

                    // Force reflow
                    answer.offsetHeight;

                    requestAnimationFrame(() => {
                        answer.style.height = '0';
                    });

                    button.setAttribute('aria-expanded', 'false');

                    setTimeout(() => {
                        item.classList.remove('closing');
                    }, 350);
                }
            }
        });
    }

    // Handle window resize
    if (!faqResizeListenerAttached) {
        let resizeTimer;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                document.querySelectorAll('.faq-section .faq-item.active .faq-answer').forEach(answer => {
                    answer.style.height = 'auto';
                });
            }, 250);
        }, { passive: true });
        faqResizeListenerAttached = true;
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFAQSection);
    } else {
        initFAQSection();
    }

    // Also initialize when Shopify sections are reloaded
    document.addEventListener('shopify:section:load', function(e) {
        if (e.target.querySelector('.faq-section')) {
            initFAQSection();
        }
    });
})();